import React, { Component, PropTypes } from "react"
import { connect } from "react-redux"
import {
  bindOnHoldSessions,
  unbindOnHoldSessions
} from "actions/paywallActions"
import UsersByDate from "./usersByDate"

class OnHoldSessions extends Component {

  static propTypes = {
    bindOnHoldSessions: PropTypes.func.isRequired,
    unbindOnHoldSessions: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.boundOnHoldSessionsRefs = {}
  }

  componentDidMount () {
    this.bindOnHoldSessions(this.props)
  }

  componentWillUnmount () {
    this.unbindOnHoldSessions()
  }

  bindOnHoldSessions (props) {
    const { bindOnHoldSessions: bind } = props;
    bind(this.boundOnHoldSessionsRefs)
  }

  unbindOnHoldSessions () {
    const { unbindOnHoldSessions: unbind } = this.props;
    unbind(this.boundOnHoldSessionsRefs)
  }

  render () {
    return (
      <UsersByDate sessionType="on hold" />
    )
  }

}

export default connect(
  (/*state*/) => ({}),
  {
    bindOnHoldSessions,
    unbindOnHoldSessions
  }
)(OnHoldSessions)



// WEBPACK FOOTER //
// ./src/views/staff/onHoldSessions.jsx